(function (angular) {
    angular
        .module('harriApp')
        .controller('getSocialLinksModal', [
            '$scope', '$state', 'modalData',
            function ($scope, $state, modalData) {

                $scope.modalData = modalData;
                $scope.basicInfo = modalData.basicInfo;

                //Hide modal
                $scope.close = function () {
                    $scope.$hide();
                };
            }]);
})(angular);
